export default __webpack_public_path__ + "media/images/slider/slider-4-ea065def731a72a62aed83bb7fa5ce00.png";